import { Tab } from "./state";

export interface Widget {
    id: string;
    title: string;
    dataKey: string;
    defaultOpen?: boolean;
    isChart?: boolean;
    chartType?: string;
}

export interface SectionConfig {
    id: string;
    title: string;
    widgets: Widget[];
    deactivated?: boolean;
}

export interface TabConfig {
    [Tab.EXECUTIVE_SUMMARY]: SectionConfig[];
    [Tab.PRE_MEMO]: SectionConfig[];
    [Tab.FULL_MEMO]: SectionConfig[];
}

export const tabSections: TabConfig = {
    [Tab.EXECUTIVE_SUMMARY]: [],

    [Tab.PRE_MEMO]: [],

    [Tab.FULL_MEMO]: [
        {
            id: "introduction",
            title: "Gumps Overview",
            widgets: [
                {
                    id: "company-overview",
                    title: "Company Overview",
                    dataKey: "companyOverview",
                    defaultOpen: true,
                },
                {
                    id: "risks",
                    title: "Risks",
                    dataKey: "risks",
                    defaultOpen: false,
                },
                {
                    id: "products-services",
                    title: "Products & Services",
                    dataKey: "productsAndServices",
                    defaultOpen: false,
                },
                {
                    id: "leadership",
                    title: "Leadership Team",
                    dataKey: "leadership",
                    defaultOpen: false,
                },
                {
                    id: "funding-valuation",
                    title: "Funding & Valuation",
                    dataKey: "fundingAndValuation",
                    defaultOpen: false,
                },
                {
                    id: "recent-developments",
                    title: "Recent Developments",
                    dataKey: "recentDevelopments",
                    defaultOpen: false,
                },
                {
                    id: "online-presence",
                    title: "Online Presence",
                    dataKey: "onlinePresence",
                    defaultOpen: false,
                },
                {
                    id: "cash_flow_progression",
                    title: "Cashflow Progression",
                    dataKey: "cashflowProgression",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "CashFlowProgression",
                },
                {
                    id: "asset_progression",
                    title: "Asset Progression",
                    dataKey: "assetProgression",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "AssetProgression",
                },
                {
                    id: "liquidity",
                    title: "Liquidity",
                    dataKey: "liquidity",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "Liquidity",
                },
            ],
        },
        {
            id: "market-background",
            title: "Market Background",
            widgets: [
                {
                    id: "summary",
                    title: "Summary, risk and missing info",
                    dataKey: "summary",
                    defaultOpen: true,
                },
                {
                    id: "porter-five-forces",
                    title: "Porter's Five Forces",
                    dataKey: "porterFiveForces",
                    defaultOpen: false,
                },
                {
                    id: "hamilton-powers",
                    title: "Hamilton Powers",
                    dataKey: "hamiltonPowers",
                    defaultOpen: false,
                },
                {
                    id: "top-competitors",
                    title: "Top Competitors",
                    dataKey: "topCompetitors",
                    defaultOpen: false,
                },
                {
                    id: "market-customers",
                    title: "Market Customers",
                    dataKey: "marketCustomers",
                    defaultOpen: false,
                },
                {
                    id: "market-niche",
                    title: "Market Niche",
                    dataKey: "marketNiche",
                    defaultOpen: false,
                },
                {
                    id: "bull-market",
                    title: "Bull Market",
                    dataKey: "bullMarket",
                    defaultOpen: false,
                },
                {
                    id: "bear-market",
                    title: "Bear Market",
                    dataKey: "bearMarket",
                    defaultOpen: false,
                },
            ],
        },
        {
            id: "team-background",
            title: "MGMT Team Background",
            widgets: [
                {
                    id: "founders",
                    title: "Founders",
                    dataKey: "founders",
                    defaultOpen: true,
                },
            ],
        },
        {
            id: "capital-deal-structure",
            title: "Capital & Deal Structure",
            widgets: [
                {
                    id: "debt_service_coverage",
                    title: "Debt Service Coverage",
                    dataKey: "debtServiceCoverage",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DebtServiceCoverage",
                },
                {
                    id: "debt_to_cashflows",
                    title: "Debt to Cashflows",
                    dataKey: "debtToCashflows",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DebtToCashflows",
                },
                {
                    id: "disbursements_and_repayments",
                    title: "Disbursements & Repayments",
                    dataKey: "disbursementsAndRepayments",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DisbursementsAndRepayments",
                },
                {
                    id: "senior_vs_other_debt",
                    title: "Debt Composition",
                    dataKey: "debtComposition",
                    defaultOpen: true,
                    isChart: true,
                    chartType: "DebtComposition",
                },
            ],
        },
        {
            id: "audit-results",
            title: "Audit Results",
            widgets: [],
            deactivated: true,
        },
        {
            id: "operational-overview",
            title: "Operational Overview",
            widgets: [],
            deactivated: true,
        },
        {
            id: "peer-analysis",
            title: "Peer Analysis",
            widgets: [],
            deactivated: true,
        },
        {
            id: "unit-economics-analysis",
            title: "Unit Economics Analysis",
            widgets: [],
            deactivated: true,
        },
        {
            id: "growth-analysis",
            title: "Growth Analysis",
            widgets: [],
            deactivated: true,
        },
        {
            id: "products-services",
            title: "Products & Services",
            widgets: [],
            deactivated: true,
        },
        {
            id: "assets-liabilities",
            title: "Assets & Liabilities",
            widgets: [],
            deactivated: true,
        },
        {
            id: "regulatory-issues",
            title: "Regulatory & Legal Issues",
            widgets: [],
            deactivated: true,
        },
        {
            id: "material-dependencies",
            title: "Material Dependencies",
            widgets: [],
            deactivated: true,
        },
    ],
};

// Helper function to get sections for a specific tab
export const getSectionsForTab = (tab: Tab): SectionConfig[] => {
    return tabSections[tab] || [];
};
